module.exports = __webpack_public_path__ + "static/media/supportNormal.ae5406dc.svg";